import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from 'react-router-dom';
import Loading from './Loading';
import { OKTA_CLIENT_ID, OKTA_ISSUER } from './constants';
import { translations } from './translations/translations';
import type { Language } from './types/translations';

interface Props {
    language: Language;
}

export const RequiredAuth = ({ language }: Props) => {
    const { oktaAuth, authState } = useOktaAuth();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (!authState) {
            return;
        }

        if (!authState?.isAuthenticated) {
            const originalUri = toRelativeUrl(window.location.href, window.location.origin);
            oktaAuth.setOriginalUri(originalUri);
            oktaAuth.signInWithRedirect({
                clientId: OKTA_CLIENT_ID,
                issuer: OKTA_ISSUER,
            });
        }
    }, [oktaAuth, !!authState, authState?.isAuthenticated]);

    if (!authState?.isAuthenticated) {
        return <Loading message={translations[language].COMMON_loading} />;
    }

    return <Outlet />;
};
